import Main from "../../../wrappers/Main";
import styled from "styled-components";

export const Container = styled(Main)``;
